import ShiftEdit from '@/components/ezuro/constants/shifts/edit/ShiftEdit.vue'
import ShiftEvents from '@/components/ezuro/constants/shifts/events/ShiftEvents.vue'
import ShiftRequirements from '@/components/ezuro/constants/shifts/requirements/ShiftRequirements.vue'
import ShiftPattern from '@/components/ezuro/constants/shifts/edit/ShiftPattern.vue';
import DaysView from '@/components/ezuro/constants/shifts/list/DaysView.vue';
import moment from 'moment';

const defaultFilterValues = {
  name: '',
  department: '',
  abbreviation: '',
  time_start: '',
  length_in_minutes: '',
  days: '',
  employees: '',
  autofill_holidays: false,
  team: '',
  pattern: '',
  pattern_start: ''
};

export default {
  name: 'ShiftList',
  components: {
    ShiftEdit,
    ShiftEvents,
    ShiftRequirements,
    ShiftPattern,
    DaysView
  },
  props: {
    editPerm: {
      type: String,
      default: 'edit-shifts'
    },
    deletePerm: {
      type: String,
      default: 'delete-shifts'
    },
    basePath: {
      type: String,
      default: 'ezuro/shifts'
    }
  },
  data () {
    return {
      loading: true,
      currentReq: null,
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'id', direction: 'asc' },
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      isMounted: false
    };
  },
  computed: {
    baseTransParam () {
      return 'shift';
    },
    editPermComp () {
      return this.editPerm;
    },
    deletePermComp () {
      return this.editPerm;
    },
    basePathComp () {
      return this.basePath
    },
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('general.item.id'), sortable: false },
        { key: 'name', label: this.$t('general.item.name'), sortable: false, filterKey: 'name' },
        { key: 'department.company_id', label: this.$t('company-structure.company.name'), sortable: false, filterKey: 'company', format: 'formatFromConfig', configKey: 'user_companies', configParam: 'name' },
        { key: 'department_id', label: this.$t('company-structure.department.name'), sortable: false, filterKey: 'department', format: 'formatFunc', funcs: [this.getDepartmentName] },
        { key: 'division_id', label: this.$t('company-structure.division.name'), sortable: false, filterKey: 'division', format: 'formatFunc', funcs: [this.getDivisionName] },
        { key: 'abbreviation', label: this.$t('shift.abbreviation'), sortable: false, filterKey: 'abbreviation' },
        { key: 'type', label: this.$t('shift.type.name'), sortable: false, filterKey: 'type', format: 'formatFunc', funcs: [this.translateType] },
        { key: 'time_start', label: this.$t('shift.time_start'), sortable: false, filterKey: 'time_start' },
        { key: 'length_in_minutes', label: this.$t('shift.length_in_minutes'), sortable: false, filterKey: 'length_in_minutes' },
        { key: 'days', label: this.$t('shift.days'), sortable: false, filterKey: 'days', type: 'slot', slotcode: 'days' },
        { key: 'employees', label: this.$t('shift.employees'), sortable: false, filterKey: 'employees' },
        { key: 'autofill_holidays', label: this.$t('shift.autofill_holidays'), sortable: false, filterKey: 'autofill_holidays', format: 'formatFunc', funcs: [this.translateAutofillHolidays] },
        { key: 'team.name', label: this.$t('shift.team'), sortable: false, filterKey: 'team' },
        { key: 'pattern', label: this.$t('shift.pattern'), sortable: false, filterKey: 'pattern', type: 'slot', slotcode: 'pattern' },
        { key: 'pattern_start', label: this.$t('shift.pattern_start'), sortable: false, filterKey: 'pattern_start', format: 'formatFunc', funcs: [this.formatPatternStart] }
      ];

      const actions = [];

      if (this.canEdit) {
        actions.push({ label: this.$t('general.actions.edit'), emit: 'editItem', bicon: 'pencil-fill', class: 'btn-sm btn-primary' });
        actions.push({ label: this.$t('shift.actions.duplicate'), emit: 'duplicate', bicon: 'copy', class: 'btn-sm btn-warning' });
        actions.push({ label: this.$t('work-schedule.requirements'), emit: 'viewRequirements', bicon: 'list', class: 'btn-sm btn-secondary' });
        actions.push({ label: this.$t('work-schedule.events'), emit: 'viewEvents', bicon: 'calendar', class: 'btn-sm btn-secondary' });
      }

      if (this.canDelete) {
        actions.push({ label: this.$t('general.actions.delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-sm btn-danger', ifconfig: { param: 'deleted_at', value: null } });
        actions.push({ label: this.$t('general.actions.enable'), emit: 'restoreItem', bicon: 'clock-history', class: 'btn-sm btn-warning', ifconfig: { param: 'deleted_at', value: null, notCheck: true } });
      }

      headers.push({ key: 'actions', label: '', actions, classTd: 'w-10' });

      return headers;
    },
    tableExpandConfig () {
      return null;
    },
    tableFilterConfig () {
      const filters = { };
      filters.name = { type: 'text', label: '', colOnlyFilter: true };
      filters.company = { type: 'text', label: '', colOnlyFilter: true };
      filters.department = { type: 'text', label: '', colOnlyFilter: true };
      filters.division = { type: 'text', label: '', colOnlyFilter: true };
      filters.abbreviation = { type: 'text', label: '', colOnlyFilter: true };
      filters.time_start = { type: 'text', label: '', colOnlyFilter: true };
      filters.type = { type: 'select', label: '', options: this.typeOptions, colOnlyFilter: true };
      filters.length_in_minutes = { type: 'text', label: '', colOnlyFilter: true };
      filters.days = { type: 'text', label: '', colOnlyFilter: true };
      filters.employees = { type: 'text', label: '', colOnlyFilter: true };
      filters.autofill_holidays = { type: 'select', options: this.yesNoOptions, label: '', colOnlyFilter: true };
      filters.team = { type: 'text', label: '', colOnlyFilter: true };
      filters.pattern_start = { type: 'text', label: '', colOnlyFilter: true };
      return filters;
    },
    canDelete () {
      return true;
    },
    canEdit () {
      return true;
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    typeOptions () {
      const types = [
        { code: 'days_one', text: this.$t('shift.type.options.days_one') },
        { code: 'days_many', text: this.$t('shift.type.options.days_many') },
        { code: 'pattern', text: this.$t('shift.type.options.pattern') }
      ];
      return types;
    },
    requestPath () {
      let path = this.ApiRequest.addGetParamsToPath(this.basePathComp + '/list?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.filterValues, true);

      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }

      return path;
    },
    tableActions () {
      const actions = { download: false };

      if (this.canEdit) {
        actions.add = { title: this.$t('general.actions.add') };
      }

      return actions;
    }
  },
  methods: {
    getDepartmentName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_departments', id, 'name', this.$i18n.locale) : null;
    },
    getDivisionName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_divisions', id, 'name', this.$i18n.locale) : null;
    },
    translateType (type) {
      return this.$t('shift.type.options.' + type);
    },
    translateAutofillHolidays (value) {
      if (value) {
        return this.$t('general.yes');
      }
      return this.$t('general.no');
    },
    formatPatternStart (value) {
      if (!value) {
        return;
      }
      return moment(value).format('DD.MM.YYYY HH:mm');
    },
    getTableData () {
      if (this.basePathComp) {
        if (this.currentReq) {
          this.currentReq.cancel('changed search query');
        }

        this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
        this.loading = true;
        this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, (response) => {
          if (response.data) {
            this.tableItems = response.data;
            this.paging = response.paging;
            this.loading = false;
          }
        });
      }
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.getTableData();
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    viewEvents (el) {
      this.$refs.modalShiftEvents.show(el);
    },
    viewRequirements (el) {
      this.$refs.modalShiftRequirements.show(el);
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    updateFilter (key, value) {
      if (this.filterValues[key] !== value) {
        this.filterValues[key] = this.BasicHelper.cloneObject(value);
        this.paging.page = 1;
        this.getTableData();
      }
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('general.item.deleteTitle'), this.$t('general.item.deleteMessage', { name: this.BasicHelper.getTranslation(el.name), code: el.time_start }))
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      this.ApiRequest.request(this.basePathComp + '/destroy/' + el.id, this.ApiRequest.REQUEST_POST, { id: el.id, deleted: isDeleted }, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
          this.loading = false;
        } else {
          this.getTableData();
        }
      });
    },
    duplicate (el, approved) {
      if (approved) {
        this.loading = true;
        this.ApiRequest.request(this.basePathComp + '/duplicate/' + el.id, this.ApiRequest.REQUEST_GET, { }, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
            this.loading = false;
          } else {
            this.getTableData();
          }
        });
      } else {
        this.$refs.itemDuplicateMsgBox.show(el, this.$t('general.item.duplicateTitle'), this.$t('general.item.duplicateMessage', { name: this.BasicHelper.getTranslation(el.name), code: el.time_start }))
      }
    }
  },
  mounted () {
    if (!this.typeId) {
      this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    } else {
      this.filterValues.type_id = this.typeId;
    }
    this.getTableData();
    this.isMounted = true;
  },
  watch: {
    basePathComp: {
      immediate: true,
      handler (val) {
        if (val) {
          this.isMounted = false;
          if (!this.typeId) {
            this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
          } else {
            this.filterValues.type_id = this.typeId;
          }
          this.getTableData();
          this.isMounted = true;
        }
      }
    }
  }
}
